import { render } from "./Join.vue?vue&type=template&id=12a1b496&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=12a1b496&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=12a1b496&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=12a1b496&scoped=true&lang=css&external"
import "./Join.vue?vue&type=style&index=3&id=12a1b496&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a1b496"]])

export default __exports__